import { ArrowRight, Eye, EyeOff, Lock, UserPlus } from 'lucide-react';
import { useState } from 'react';
import toast from 'react-hot-toast';
import axios from 'axios';
import { API_BASE, guardarSesion } from '../api';

export default function AceptarInvitacion({ uid, token, onAuth }) {
  const [password, setPassword] = useState('');
  const [mostrarPassword, setMostrarPassword] = useState(false);
  const [cargando, setCargando] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setCargando(true);
    try {
      const res = await axios.post(`${API_BASE}/equipo/aceptar-invitacion/`, {
        uid, token, password,
      });
      guardarSesion(res.data.token, res.data.empresa);
      toast.success('Cuenta activada. ¡Bienvenido al equipo!');
      window.history.replaceState({}, '', window.location.pathname);
      onAuth(res.data.empresa);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No se pudo activar la cuenta. El enlace puede haber expirado.');
    } finally {
      setCargando(false);
    }
  }

  return (
    <div className="auth-card">
      <div className="auth-icono"><UserPlus size={22} /></div>
      <h2>Activa tu cuenta</h2>
      <p className="auth-subtitulo">Crea tu contraseña para unirte al equipo</p>

      <form onSubmit={handleSubmit}>
        <label>Contraseña</label>
        <div className="input-con-icono">
          <Lock size={16} />
          <input
            type={mostrarPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Mínimo 8 caracteres"
            required
            minLength={8}
          />
          <button
            type="button"
            className="toggle-password"
            onClick={() => setMostrarPassword((v) => !v)}
            aria-label={mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
          >
            {mostrarPassword ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>

        <button className="btn-primary" type="submit" disabled={cargando}>
          <ArrowRight size={16} /> {cargando ? 'Activando…' : 'Activar cuenta'}
        </button>
      </form>
    </div>
  );
}
